import { gql } from '@apollo/client';
import type {
  OpdsAccountType,
  OpdsAccountPageResponseType,
  OpdsAccountQueryConditionInput,
} from '../../../personnel/graphql/queries/queryOpdsAccountByPage';

export const QUERY_ACCOUNT_BY_ROLE_PAGE = gql`
  query QueryAccountByRolePage(
    $roleId: Long!
    $condition: OpdsAccountQueryConditionInput
    $pageRequest: PageRequestTypeInput
  ) {
    queryAccountByRolePage(roleId: $roleId, condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        name
        countryCode
        phone
        status
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface QueryAccountByRolePageResponse {
  queryAccountByRolePage: OpdsAccountPageResponseType;
}

export interface QueryAccountByRolePageVariables {
  roleId: number;
  condition?: OpdsAccountQueryConditionInput | null;
  pageRequest?: PageRequestTypeInput | null;
}

export type { OpdsAccountType, OpdsAccountQueryConditionInput };
